import { type IconType } from "..";

const SupportIcon: IconType = (props) => {
  const fill = props.fill ?? "fill-white";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.5 25.6"
      className={`${props.size}`}
      {...props}
    >
      <path
        className={`${fill}`}
        d="M21.4 16.8c-.1 0-.2 0-.3-.2-.1-.2 0-.4.1-.5l5.5-3.5c0-.4 0-.8-.4-1-.4-.2-.8-.1-1.1.2l-3.7 4c-.1.2-.4.2-.5 0-.2-.1-.2-.4 0-.5l3.7-4c.5-.6 1.4-.7 2-.3.7.4 1 1.3.7 2 0 0 0 .1-.1.2l-5.7 3.6h-.2M19.9 12.2H18c-.2 0-.4-.2-.4-.4V9.6h-2.2c-.2 0-.4-.2-.4-.4V7.3c0-.2.2-.4.4-.4h2.2V4.7c0-.2.2-.4.4-.4h1.9c.2 0 .4.2.4.4v2.2h2.2c.2 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-2.2v2.2c0 .2-.2.4-.4.4m-1.5-.8h1.2V9.2c0-.2.2-.4.4-.4h2.2V7.6H20c-.2 0-.4-.2-.4-.4V5h-1.2v2.2c0 .2-.2.4-.4.4h-2.2v1.2H18c.2 0 .4.2.4.4v2.2Z"
      />
      <path
        className={`${fill}`}
        d="M28.7 13.9c0 .3-.2.5-.4.7l-5.9 4c-.2.2-.5.2-.8.2h-6.5c-.6 0-1.2.2-1.7.7 0-.1-2.6-3.4-2.6-3.4.9-.9 1.9-1.5 2.9-1.9 1.8-.7 3.7-.6 4.9-.5h.8s.1 0 .2.1.2.2.3.4c0 0 0 .1.1.2 0 0 0 .1.1.2v.2c0 .2.1.4.1.6h-4.4c-.2 0-.4.2-.4.4s.2.4.4.4h4.8l5.8-3.7c.4-.2.8-.2 1.1.1.2.2.3.4.3.7m-14.6 7.8c0 .3-.2.5-.5.7l-.3.2-4.8-6.1.6-.3c.4-.2.9-.1 1.2.2l3.6 4.5c.1.2.2.5.2.7m-5.6 3.7-6.5-5.2 5.8-3.2 4.8 6.1-4.1 2.3Zm21.4-12c-.6-.6-1.4-.6-2.1-.2l-5.3 3.4v-.2l3.7-3.9c.2-.2.6-.3.9-.3.2 0 .4 0 .5-.2.4-1 .6-2 .6-3s-.2-1.9-.5-2.8c0-.2-.1-.3-.2-.5 0-.2-.3-.3-.5-.2-.2 0-.3.3-.2.5 0 .2.1.3.2.5.3.8.4 1.6.4 2.5s-.1 1.6-.4 2.4c-.5 0-1 .2-1.3.5l-3.4 3.7c-.3-.6-.8-1-1.3-1.4h-.2s-.2 0-.2-.1H18.8c-1.4-.2-3.1-.1-4.7.5-1.3-1.4-2-3.2-2-5.1 0-4.1 3.3-7.4 7.5-7.4s.4-.2.4-.4-.8-1-1-1c-4.6 0-8.3 3.7-8.3 8.2s.7 3.9 2 5.4c-.9.4-1.8 1-2.6 1.8l-.2-.2c-.5-.7-1.5-.9-2.2-.4L.2 19.1c-.1 0-.2.2-.2.3 0 .1 0 .3.1.3l7.2 5.8h.4l5.3-3.1c.4-.3.7-.7.8-1.2 0-.4 0-.7-.1-1.1.4-.3.8-.5 1.3-.5h6.5c.4 0 .9-.2 1.2-.4l5.9-4c.4-.3.7-.7.7-1.2s-.1-1-.5-1.3"
      />
      <path
        className={`${fill}`}
        d="M24.8 3.5s.2.1.3.1h.2c.2-.1.2-.4 0-.5-.2-.3-.5-.6-.8-.8-.2-.1-.4-.1-.6 0-.1.2-.1.4 0 .6l.7.7M21.5 1.2c.3.1.6.2.9.4h.2c.1 0 .3 0 .3-.2.1-.2 0-.4-.2-.5-.3-.2-.7-.3-1-.4-.2 0-.4 0-.5.2 0 .2 0 .4.2.5"
      />
    </svg>
  );
};

export default SupportIcon;
